<template>
 <v-container style="width:640px">
   <v-row justify="center">
     <div style="position: relative">
       <transition name="fade" mode="out-in">
         <LocalWebcam
             v-if="currentDisplayState==='webcam'"
             ref="webcam"
             :width="processedWidth"
             :height="processedHeight"
             @error="onError($event)"
             @active="onActive($event)"
             @inactive="onInactive($event)"
             @loading="onLoadingChanged($event)"
             @reset="reset()"
             @countdown-started="isCountdownActive=true"
             @countdown-ended="isCountdownActive=false"
             :countdown="countdown"
             :minimum-recording-secs="minSeconds"
             :play-sounds="true"
             @responsevideo="onResponsevideoReceived"
             :assessmentanswerid="assessmentanswerid"
             :assessmentid="assessmentid"
             @uploading="onUploading($event)"
             :blur="blur"
             :enforce-to-stay-in-browser="true"
         ></LocalWebcam>
         <VideoPlayback v-else
                        :responsevideo="value"
                        :width="processedWidth"
                        :height="processedHeight"
                        ref="video"
                        @progress="setPlaybackProgress($event)"
                        @playback-started="playbackStarted($event)"
                        @playback-stopped="playbackStopped($event)"
                        @retrieve-video="refreshResponsevideo()"
                        @waiting="isWaitingToPlay=$event"
                        :blur="blur"
         >

         </VideoPlayback>
       </transition>
     </div>
   </v-row>
   <v-row>
     <VideoResponseControls
         :disabled="isLoading"
         :action="currentAction"
         :min-seconds="minSeconds"
         :max-seconds="relevantMaxSeconds"
         :progress="progress"
         :buffered="buffered"
         :attempts="attempts"
         :current-attempt="currentAttempt + (wantsToRetry?1:0)"
         :countdownColor="progressWarningLevel || 'white'"
         :is-playing="isPlaying || isWaitingToPlay"
         @retry="onRetryClick"
         @start_recording="onRecordingStartClick"
         @stop_recording="onRecordingStopClick"
         @preview_video="onPreviewClick"
         @preview_video_pause="onPreviewPauseClick"
         @seek="seek($event)"
         @switch-responsevideo="switchVideo($event)"
         :value="value"
         :responsevideos="responsevideos"
     ></VideoResponseControls>
   </v-row>
 </v-container>
</template>

<script>
  import VideoResponseControls from "./VideoResponseControls";
  import VideoPlayback from "./playback/VideoPlayback";
  import {cacheUrl} from "../../lib/cache";
  import soundController from "../../lib/soundController";
  import LocalWebcam from "./LocalWebcam";
  export default {
    name: "VideoRecording",
    components:{
        LocalWebcam,
      VideoResponseControls,
      VideoPlayback
    },
    props:{
      value : {
      },
      responsevideos:{
        type:Array,
        default:()=>[]
      },
      countdown : {
        default:3
      },
      minSeconds : {
        default:5
      },
      maxSeconds: {
        default : 120
      },
      maxExtension: {
        default:30
      },
      warningBeforeEnd: {
        default:30
      },
      attempts:{
        default: 1
      },
      currentAttempt: {
        type: Number,
        default: 0
      },
      assessmentanswerid: {
        default: null
      },
        assessmentid: {
            default: null
        }
    },
    data(){
      return {
        progressInterval:null,
        progress : 0,
        buffered : 0,
        isActive:false,
        isLoading:false,
        progressWarningLevel:null,
        isCountdownActive:false,
        responsevideo:null,
        error:null,
        wantsToRetry:false,
        playbackDuration:null,
        isPlaying : false,
        isWaitingToPlay : false,
        processedWidth : 640,
        processedHeight : 480,
      }
    },
    created(){
      this.processedWidth=Math.min(((window.screen.height*0.4) / 480)*640,640);
      this.processedHeight=(this.processedWidth/640)*480;
    },
    computed:{
      blur(){
          return this.$store.state.assessment.assessment.person.hide_picture==1;
      },
      currentAction(){
        if(this.isActive || this.isCountdownActive){
          return 'stop_recording';
        }else if(this.value && !this.wantsToRetry){
          return 'preview_video';
        }else{
          return 'start_recording';
        }
      },
      currentDisplayState(){
        if(this.isActive || this.isCountdownActive || this.wantsToRetry){
          return 'webcam';
        }else if(this.value){
          return 'complete';
        }
        return 'webcam';
      },
      relevantMaxSeconds(){
        if(this.currentDisplayState==='complete' && this.playbackDuration){
          return this.playbackDuration;
        }else{
          return this.maxSeconds;
        }
      }

    },
    methods:{
      reset(){
        this.progressWarningLevel=null;
        this.progress=0;
        this.buffered=0;
        this.error=null;
        this.isActive=false;
        clearInterval(this.progressInterval);
      },
      start(){
         this.reset();
         this.$refs.webcam.start();
      },
      stop(){
        this.$refs.webcam.stop();
      },
      emitInput(){
        if(!this.error){
          this.$emit('input',this.responsevideo);
          this.wantsToRetry = false;
          soundController.alert();
        }
      },
      onRecordingStartClick(){
        this.start();
      },
      onRetryClick(){
        if(this.currentDisplayState!=='webcam'){
          this.onPreviewPauseClick();
        }
        this.progress = 0;
        this.wantsToRetry = true;
      },
      onRecordingStopClick(){
        this.stop();
        if(this.progress < this.minSeconds){
          soundController.beep();
        }
      },
      onPreviewClick(){
        this.$refs.video.play();
      },
      onPreviewPauseClick(){
        this.$refs.video.stop();
      },
      onError(err){
        this.reset();
        this.error=err;
      },
      onResponsevideoReceived(responsevideo){
         this.responsevideo=responsevideo;
         this.emitInput();
      },
      onLoadingChanged(loading){
        this.isLoading=loading;
      },
      onActive(){
        this.progressInterval=setInterval(this.onProgressTick,1000);
        this.isActive=true;
      },
      onInactive(){

      },
      onUploading(uploading){
         if(!uploading){
           this.isLoading = false;
         }else{
             this.isLoading=true;
             this.reset();
         }
      },
      onProgressTick(){
        this.progress++;
        this.playbackDuration=this.progress;
        this.calculateProgressWarningLevel();
        if(this.progress>=this.maxSeconds + this.maxExtension){
          this.stop();
          soundController.warning();
        }
      },
      calculateProgressWarningLevel(){
        if(this.progress>=this.maxSeconds && this.progressWarningLevel!=='error'){
          this.progressWarningLevel='error';
          soundController.warning2();
        }else if(this.progress>=this.maxSeconds - this.warningBeforeEnd  && this.progressWarningLevel!=='warning'){
          this.progressWarningLevel='warning';
          soundController.beep2();
        }
      },
      refreshResponsevideo(){
          if(!this.value || !this.value.responsevideoid){
            return;
          }
          this.$http.get('responsevideos/'+this.value.responsevideoid).then((response)=>{
             const rv=response.data.data;
             if(rv.file){
               this.$emit('video-updated',rv);
             }
          });
      },
      switchVideo(rv){
          if(this.currentDisplayState==='complete'){
            this.onPreviewPauseClick();
          }

        this.$emit('video-updated',rv);
        this.wantsToRetry = false;
      },
      playbackStarted(info){
        if(!Number.isNaN(info.duration) && Number.isFinite(info.duration)){
          this.playbackDuration=info.duration;
        }
        this.isPlaying=true;
      },
      playbackStopped(){
        this.isPlaying=false;
      },
      seek(perc){
        this.$refs.video.seek(perc);
      },
      setPlaybackProgress(event){
         this.progress=event.progress;
         this.buffered=event.buffered;
      },
      cacheThumbnails(){
        if(!this.responsevideos) return null;
        for(let rv of this.responsevideos){
          if(rv.thumbnail && rv.thumbnail.url){
            cacheUrl(rv.thumbnail.url);
          }
        }
      }
    },
    mounted() {
      this.cacheThumbnails();
    }
  }
</script>

<style scoped>

</style>
